import { combineReducers } from 'redux'
import { SET_PAYMENT_DETAILS } from './constants'

const defaultPayment = {
  paymentType: 'card',
  cardType: '',
  cardNumber: '',
  expiryDate: '', // MM-20YY
  cvv: '',
}

const details = (state = defaultPayment, { type, payload }) => {
  switch (type) {
    case SET_PAYMENT_DETAILS:
      return { ...payload }
    default:
      return state
  }
}

export const paymentReducer = combineReducers({
  details,
})



// WEBPACK FOOTER //
// ./src/containers/Cart/Payment/paymentReducer.js